export default __webpack_public_path__ + "static/media/timer-2.8b08a6ba.svg";